import {
  Grid,
  Paper,
  CardActionArea,
  CardContent,
  Typography,
  Avatar,
  Divider,
} from '@mui/material';
import { Contact } from './simulator.slice';
import classes from './simulator.module.scss';

/**
 * To show the list of contacts
 * @param props - its will take the list of conatct , current selected conatct and the onclick handler method
 * @returns
 * @example
 */
export default function ContactListCard(props: {
  contact: Contact[];
  selectedContactIndex: number;
  handleTabSelection: (value: number) => void;
}) {
  const { contact, selectedContactIndex, handleTabSelection } = props;

  return (
    <Grid className={classes.simulatorColumn}>
      <Paper elevation={6} className={classes.simulatorPaperWithFullheight}>
        {contact.map((contact: Contact, index: number) => (
          <>
            <CardActionArea
              key={contact.id}
              className={`${classes.simulatorCard} ${
                selectedContactIndex === index
                  ? classes.simulatorCardSelected
                  : ''
              }`}
              id={`sm_contactList_${
                contact.customer?.firstName + ' ' + contact.customer?.lastName
              }`}
              onClick={() => handleTabSelection(index)}
            >
              <CardContent
                sx={{ padding: '10px' }}
                className={classes.simulatorCardContent}
              >
                <Typography color="primary">
                  {contact.customer?.firstName +
                    ' ' +
                    contact.customer?.lastName}
                </Typography>
                <Typography color="textSecondary">
                  {contact.messageType}
                </Typography>
                <Typography color="textSecondary" variant="caption">
                  {contact.media}
                </Typography>
              </CardContent>
              <Avatar
                style={{ marginRight: '20px' }}
                aria-label="recipe"
                className={classes.avatarRoot}
                variant={'circular'}
              >
                {contact.customer?.firstName?.charAt(0)}
              </Avatar>
            </CardActionArea>
            <Divider />
          </>
        ))}
      </Paper>
    </Grid>
  );
}
